(() => {
  const MCGILL = new Set(['11081302573249','11081304670401','11085742702785','11085780713665']);
  const fetchCart = window.fetch.bind(window);
  let cart = null;
  let saving = false;
  let refreshTimer;
  let cleanupTimer;

  function attrs(c) {
    return c?.attributes || {};
  }

  function regularOnly(c) {
    return c?.item_count > 0 && (c.items || []).every((item) => !MCGILL.has(String(item.product_id)));
  }

  function hasMcGill(c) {
    return c?.item_count > 0 && (c.items || []).some((item) => MCGILL.has(String(item.product_id)));
  }

  function selected(c) {
    return String(attrs(c)['Complimentary Message Card'] || '').toLowerCase() === 'yes';
  }

  function message(c) {
    return attrs(c)['Card Message'] || '';
  }

  function cartContext(el) {
    return location.pathname.replace(/\/$/, '').endsWith('/cart') ||
      !!el?.closest('.mini-cart,cart-drawer,[id="MiniCart"],[id*="mini-cart" i],form#cart');
  }

  function styles() {
    if (document.getElementById('mmp-card-style')) return;
    const style = document.createElement('style');
    style.id = 'mmp-card-style';
    style.textContent = `
      gift-wrapping, cart-note { display: none !important; }
      .mmp-card { margin: 0 0 18px; padding: 16px; border: 1px solid #d7d7d7; border-radius: 8px; background: #fff; text-align: left; }
      .mmp-card__toggle { display: flex; align-items: flex-start; gap: 10px; cursor: pointer; font-size: 15px; line-height: 1.4; }
      .mmp-card__toggle input { width: 18px; height: 18px; margin: 1px 0 0; flex: 0 0 auto; }
      .mmp-card__body { margin-top: 12px; }
      .mmp-card__body[hidden] { display: none !important; }
      .mmp-card__body label { display: grid; gap: 6px; font-size: 14px; font-weight: 600; }
      .mmp-card textarea { box-sizing: border-box; width: 100%; min-height: 96px; padding: 10px; resize: vertical; border: 1px solid #bbb; border-radius: 5px; background: #fff; font: inherit; }
      .mmp-card__hint { margin: 6px 0 0; font-size: 12px; opacity: .68; }
      .mmp-card__status { min-height: 16px; margin-top: 6px; font-size: 12px; opacity: .7; }
      .mmp-card.saving { opacity: .65; pointer-events: none; }
    `;
    document.head.appendChild(style);
  }

  function cleanLegacyUi() {
    document.querySelectorAll('gift-wrapping, cart-note').forEach((el) => el.remove());

    document.querySelectorAll('gift-note').forEach((el) => {
      const action = el.closest('.mini-cart__action');
      if (action) action.remove();
      else el.remove();
    });

    document.querySelectorAll('.mini-cart__actions').forEach((actions) => {
      actions.querySelectorAll('.mini-cart__action').forEach((action) => {
        if (action.querySelector('gift-note,cart-note')) action.remove();
      });
      if (!actions.children.length) actions.remove();
    });
  }

  function targets() {
    const out = [];
    document.querySelectorAll('.cart__ctas').forEach((checkout) => {
      if (cartContext(checkout) && checkout.parentElement) out.push(['page', checkout.parentElement, checkout]);
    });
    document.querySelectorAll('.mini-cart .button-container,cart-drawer .button-container').forEach((checkout) => {
      if (checkout.parentElement) out.push(['drawer', checkout.parentElement, checkout]);
    });
    return out;
  }

  function createCard(key) {
    const el = document.createElement('div');
    el.className = 'mmp-card';
    el.dataset.mmpCard = key;
    el.innerHTML = `
      <label class="mmp-card__toggle">
        <input type="checkbox" data-mmp-card-toggle>
        <span><strong>Add a complimentary message card</strong></span>
      </label>
      <div class="mmp-card__body" data-mmp-card-body hidden>
        <label>Card message
          <textarea rows="4" maxlength="300" data-mmp-card-message placeholder="Write your message here"></textarea>
        </label>
        <p class="mmp-card__hint">One complimentary card per order.</p>
      </div>
      <div class="mmp-card__status" data-mmp-card-status aria-live="polite"></div>
    `;
    return el;
  }

  function syncCard(el, c) {
    const on = selected(c);
    const toggle = el.querySelector('[data-mmp-card-toggle]');
    const body = el.querySelector('[data-mmp-card-body]');
    const textarea = el.querySelector('[data-mmp-card-message]');
    toggle.checked = on;
    body.hidden = !on;
    textarea.value = on ? message(c) : '';
    el.classList.toggle('saving', saving);
    el.querySelector('[data-mmp-card-status]').textContent = saving ? 'Saving…' : '';
  }

  function setSavingState(on) {
    saving = on;
    document.querySelectorAll('[data-mmp-card]').forEach((el) => el.classList.toggle('saving', on));
    document.querySelectorAll('[data-mmp-card-status]').forEach((el) => { el.textContent = on ? 'Saving…' : ''; });
    document.querySelectorAll('button[name="checkout"],input[name="checkout"]').forEach((button) => {
      if (!cartContext(button)) return;
      if (on) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.mmpCardDisabled = '1';
      } else if (button.dataset.mmpCardDisabled) {
        if (button.dataset.mmpDdDisabled !== '1' && button.dataset.mcgillGuardDisabled !== 'true') {
          button.disabled = cart?.item_count === 0;
          if (!button.disabled) button.removeAttribute('aria-disabled');
        }
        delete button.dataset.mmpCardDisabled;
      }
    });
  }

  async function readCart() {
    const response = await fetchCart('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart read failed');
    return response.json();
  }

  async function updateAttributes(changes) {
    const response = await fetchCart('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { ...attrs(cart), ...changes } })
    });
    if (!response.ok) throw new Error('cart update failed');
    return response.json();
  }

  async function saveCard(on, text) {
    if (saving || !cart) return;
    setSavingState(true);
    try {
      cart = await updateAttributes({
        'Complimentary Message Card': on ? 'Yes' : '',
        'Card Message': on ? String(text || '').trim() : ''
      });
      render(cart);
    } catch (error) {
      document.querySelectorAll('[data-mmp-card-status]').forEach((el) => {
        el.textContent = 'Could not save the card message. Please try again.';
      });
    } finally {
      setSavingState(false);
      if (cart) render(cart);
    }
  }

  async function clearIncompatibleAttributes(c) {
    if (saving) return;
    const a = attrs(c);
    const hasNewCard = !!a['Complimentary Message Card'] || !!a['Card Message'];
    const hasLegacyGift = !!a['gift-wrapping'] || !!a['gift-note'];
    const shouldClearNewCard = hasNewCard && (hasMcGill(c) || c.item_count === 0);
    if (!shouldClearNewCard && !hasLegacyGift) return;

    setSavingState(true);
    try {
      cart = await updateAttributes({
        ...(shouldClearNewCard ? { 'Complimentary Message Card': '', 'Card Message': '' } : {}),
        ...(hasLegacyGift ? { 'gift-wrapping': '', 'gift-note': '' } : {})
      });
    } catch (error) {
      // Keep storefront usable even if cleanup fails.
    } finally {
      setSavingState(false);
      if (cart) render(cart);
    }
  }

  function render(c) {
    cart = c;
    styles();
    cleanLegacyUi();

    if (!regularOnly(c)) {
      document.querySelectorAll('[data-mmp-card]').forEach((el) => el.remove());
      clearTimeout(cleanupTimer);
      cleanupTimer = setTimeout(() => clearIncompatibleAttributes(c), 0);
      return;
    }

    targets().forEach(([key, parent, before]) => {
      let el = parent.querySelector(`[data-mmp-card="${key}"]`);
      if (!el) {
        el = createCard(key);
        parent.insertBefore(el, before);
      }
      syncCard(el, c);
    });

    clearTimeout(cleanupTimer);
    cleanupTimer = setTimeout(() => clearIncompatibleAttributes(c), 0);
  }

  document.addEventListener('change', (event) => {
    const card = event.target.closest?.('[data-mmp-card]');
    if (!card || !cart || !regularOnly(cart)) return;

    if (event.target.matches('[data-mmp-card-toggle]')) {
      const on = event.target.checked;
      const text = card.querySelector('[data-mmp-card-message]')?.value || '';
      card.querySelector('[data-mmp-card-body]').hidden = !on;
      saveCard(on, text);
      return;
    }

    if (event.target.matches('[data-mmp-card-message]')) {
      const on = card.querySelector('[data-mmp-card-toggle]')?.checked;
      if (on) saveCard(true, event.target.value);
    }
  });

  async function refresh() {
    if (saving) return;
    try {
      render(await readCart());
    } catch (error) {
      // No action needed.
    }
  }

  function later() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 220);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();

  const observer = new MutationObserver((mutations) => {
    const meaningful = mutations.some((mutation) => [...mutation.addedNodes].some((node) =>
      node.nodeType === 1 && !node.closest?.('[data-mmp-card]')
    ));
    if (meaningful) {
      cleanLegacyUi();
      later();
    }
  });

  const start = () => document.body && observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
